<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <v-icon class="mr-2 mb-1" @click="$router.go(-1)"
          >mdi-arrow-left</v-icon
        >
        Competition Analytics
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="ma-2">
      <v-card-text>
        <v-row>
          <v-col cols="7">
            <span class="text-h5 font-weight-medium">{{
              paramsValue.name
            }}</span>
          </v-col>
          <v-col align="end">
            <v-btn
              small
              color="secondary"
              @click="$refs.leaderboardDialog.openLeaderboard()"
            >
              Leaderboard
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="7">
            <span class="text-subtitle-1 grey--text">{{
              compAnalytics.quizName +
              "(" +
              compAnalytics.totalQuestions +
              " questions )"
            }}</span>
          </v-col>
          <v-col align="end">
            <span>
              <v-chip class="ml-2" label v-if="paramsValue.grades.length < 2">
                Grade: {{ paramsValue.grades[0] }}
              </v-chip>
              <v-chip class="ml-2" label v-else>
                Grades: {{ paramsValue.grades.join(", ") }}
              </v-chip>
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="5" class="d-flex flex-column justify-center">
            <v-card flat>
              <div v-if="compAnalytics && Object.keys(compAnalytics).length">
                <ChartComponent :data="chartData" :options="chartOptions" />
              </div>
              <div
                v-else
                class="d-flex flex-column align-center justify-center"
              >
                <v-img
                  max-width="1.5rem"
                  contain
                  src="../assets/No-Data.png"
                ></v-img>
                <span class="mt-1 font-weight-bold"
                  >Uh! No Data Available At The Moment</span
                >
              </div>
              <v-row class="ma-1 pt-5">
                <v-col cols="5" class="d-flex align-center flex-column">
                  <v-progress-circular
                    :rotate="-90"
                    :size="70"
                    :width="9"
                    :value="compAnalytics.completionPercentage"
                    color="teal"
                    class="mb-2"
                  >
                    {{ compAnalytics.completionPercentage + "%" }}
                  </v-progress-circular>
                  <div class="text-center">
                    <span class="text-body-3 grey--text"
                      >Completion percent</span
                    >
                  </div>
                </v-col>

                <v-col>
                  <div>
                    <v-row>
                      <v-col
                        ><span class="text-body-3 grey--text"
                          >Average Score:</span
                        ></v-col
                      >
                      <v-col
                        ><span class="text-body-3 font-weight-medium">
                          {{ compAnalytics.averageScore }}
                        </span></v-col
                      >
                    </v-row>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div>
                    <v-row>
                      <v-col
                        ><span class="text-body-3 grey--text"
                          >Average Time:</span
                        ></v-col
                      >
                      <v-col
                        ><span class="text-body-3 font-weight-medium">
                          {{ compAnalytics.averageTime ?? "-" }}
                        </span></v-col
                      >
                    </v-row>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div>
                    <v-row>
                      <v-col
                        ><span class="text-body-3 grey--text"
                          >Conins Distributed:</span
                        ></v-col
                      >
                      <v-col
                        ><span class="text-body-3 font-weight-medium">
                          {{ compAnalytics.coinsDistrubuted }}
                        </span></v-col
                      >
                    </v-row>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div>
                    <v-row>
                      <v-col
                        ><span class="text-body-3 grey--text"
                          >Certificates Issued:</span
                        ></v-col
                      >
                      <v-col
                        ><span class="text-body-3 font-weight-medium">
                          {{ compAnalytics.certsCreated }}
                        </span></v-col
                      >
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="7">
            <v-card elevation="0">
              <v-simple-table class="ma-1 mytable">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th>
                        <v-icon class="ml-1 profileIcon" small>
                          mdi-circle
                        </v-icon>
                        Total Enrolled:
                      </th>
                      <td>
                        <span> {{ compAnalytics.enrolled ?? "-" }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <v-icon class="ml-1 profileIcon" small>
                          mdi-circle
                        </v-icon>
                        Total Participants:
                      </th>
                      <td>
                        <span> {{ compAnalytics.participants ?? "-" }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <v-icon class="ml-1 profileIcon" small>
                          mdi-circle
                        </v-icon>
                        Highest Score:
                      </th>
                      <td>
                        <span> {{ compAnalytics.highestScore ?? "-" }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <v-icon class="ml-1 profileIcon" small>
                          mdi-circle
                        </v-icon>
                        Lowest Score:
                      </th>
                      <td>
                        <span>{{ compAnalytics.lowestScore ?? "-" }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <v-icon class="ml-1 profileIcon" small>
                          mdi-circle
                        </v-icon>
                        Duration:
                      </th>
                      <td>
                        <span>{{ compAnalytics.duration ?? "-" }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <v-icon class="ml-1 profileIcon" small>
                          mdi-circle
                        </v-icon>
                        Max Time:
                      </th>
                      <td>
                        <span>{{ compAnalytics.maxTime ?? "-" }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <v-icon class="ml-1 profileIcon" small>
                          mdi-circle
                        </v-icon>
                        Min Time:
                      </th>
                      <td>
                        <span>{{ compAnalytics.minTime ?? "-" }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <CompetitionLeaderBoardDialog ref="leaderboardDialog" />
  </div>
</template>

<script>
import ChartComponent from "./ChartComponent.vue";
import CompetitionLeaderBoardDialog from "./dialogComponents/CompetitionLeaderBoardDialog.vue";
import {
  BASE_URL,
  QUIZ_COMPETITION_ADMIN_ANALYTICS,
} from "@/common/apiEndpoints";
import { getAxiosOptions } from "@/common/utility";
import { GET_TOKEN, GET_USER_TYPE, GET_PARAMS_VALUE } from "@/store/getters";
import { SET_API_SUCCESS, SET_OVERLAY_VALUE } from "@/store/mutations";
import axios from "axios";
import {
  USER_TYPE_CONTENT_MANAGER,
  USER_TYPE_RESOURCE_MANAGER,
  STATUS_PUBLISHED,
} from "@/common/constants";
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      USER_TYPE_CONTENT_MANAGER: USER_TYPE_CONTENT_MANAGER,
      USER_TYPE_RESOURCE_MANAGER: USER_TYPE_RESOURCE_MANAGER,
      STATUS_PUBLISHED: STATUS_PUBLISHED,
      compAnalytics: {},
      compStudents: [],
    };
  },
  components: {
    ChartComponent,
    CompetitionLeaderBoardDialog,
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
      userType: `schoolModule/${GET_USER_TYPE}`,
      paramsValue: `schoolModule/${GET_PARAMS_VALUE}`,
    }),

    chartData() {
      const totalStudents = this.compStudents.length;
      const totalQuestions = this.compAnalytics.totalQuestions || 0;
      const totalDuration =
        Number(this.compAnalytics.duration.replace(" Minutes", "")) * 60 || 0; // Convert minutes to seconds

      if (totalStudents === 0 || totalQuestions === 0) {
        return {
          labels: [],
          datasets: [
            {
              label: "Attempted",
              data: [],
              backgroundColor: "#ffcd56",
              borderColor: "#ffcd56",
              showLine: false,
              pointRadius: 5,
            },
            {
              label: "Correct",
              data: [],
              backgroundColor: "#4bc0c0",
              borderColor: "#4bc0c0",
              showLine: false,
              pointRadius: 5,
            },
            {
              label: "Incorrect",
              data: [],
              backgroundColor: "#ff6384",
              borderColor: "#ff6384",
              showLine: false,
              pointRadius: 5,
            },
            {
              label: "Duration",
              data: [],
              backgroundColor: "#a78bfa",
              borderColor: "#a78bfa",
              showLine: false,
              pointRadius: 5,
            },
          ],
        };
      }

      const countAttempted = new Array(totalQuestions + 1).fill(0);
      const countCorrect = new Array(totalQuestions + 1).fill(0);
      const countIncorrect = new Array(totalQuestions + 1).fill(0);
      const countDuration = new Array(totalDuration + 1).fill(0); // 0-100% duration buckets

      this.compStudents.forEach((student) => {
        const a = Math.max(
          0,
          Math.min(totalQuestions, student.attemptedQuestions || 0)
        );
        const c = Math.max(
          0,
          Math.min(totalQuestions, student.correctQuestions || 0)
        );
        const i = Math.max(
          0,
          Math.min(totalQuestions, student.incorrectQuestions || 0)
        );
        const d = Math.max(0, Math.min(totalDuration, student.duration || 0));
        countAttempted[a]++;
        countCorrect[c]++;
        countIncorrect[i]++;
        countDuration[d]++;
      });

      const attemptedPoints = [];
      const correctPoints = [];
      const incorrectPoints = [];
      const durationPoints = [];

      for (let q = 0; q <= totalQuestions; q++) {
        const pA = +((countAttempted[q] / totalStudents) * 100).toFixed(2);
        const pC = +((countCorrect[q] / totalStudents) * 100).toFixed(2);
        const pI = +((countIncorrect[q] / totalStudents) * 100).toFixed(2);
        const qPercent = +((q / totalQuestions) * 100).toFixed(2);
        if (pA > 0) attemptedPoints.push({ x: pA, y: qPercent });
        if (pC > 0) correctPoints.push({ x: pC, y: qPercent });
        if (pI > 0) incorrectPoints.push({ x: pI, y: qPercent });
      }

      for (let d = 0; d <= totalDuration; d++) {
        const pD = +((countDuration[d] / totalStudents) * 100).toFixed(2);
        const dPercent = +((d / totalDuration) * 100).toFixed(2);
        if (pD > 0) durationPoints.push({ x: pD, y: dPercent });
      }

      return {
        labels: [
          "0%",
          "10%",
          "20%",
          "30%",
          "40%",
          "50%",
          "60%",
          "70%",
          "80%",
          "90%",
          "100%",
        ],
        datasets: [
          {
            label: "Attempted",
            data: attemptedPoints,
            backgroundColor: "#ffcd56",
            borderColor: "#ffcd56",
            showLine: true,
            fill: false,
            tension: 0.4,
            pointRadius: 4,
          },
          {
            label: "Correct",
            data: correctPoints,
            backgroundColor: "#4bc0c0",
            borderColor: "#4bc0c0",
            showLine: true,
            fill: false,
            tension: 0.4,
            pointRadius: 4,
          },
          {
            label: "Incorrect",
            data: incorrectPoints,
            backgroundColor: "#ff6384",
            borderColor: "#ff6384",
            showLine: true,
            fill: false,
            tension: 0.4,
            pointRadius: 4,
          },
          {
            label: "Duration",
            data: durationPoints,
            backgroundColor: "#a78bfa",
            borderColor: "#a78bfa",
            showLine: true,
            fill: false,
            tension: 0.4,
            pointRadius: 4,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                const x = context.parsed.x;
                const y = context.parsed.y;
                return `${x}% of students → ${y}% ${context.dataset.label}`;
              },
            },
          },
        },
        scales: {
          x: {
            type: "linear",
            min: 0,
            max: 100,
            title: {
              display: true,
              text: "Percentage of Students (%)",
            },
            ticks: {
              stepSize: 10,
              callback: function (value) {
                return value + "%";
              },
            },
          },
          y: {
            type: "linear",
            min: 0,
            max: 100,
            ticks: {
              stepSize: 10,
              callback: function (value) {
                return value + "%";
              },
            },
            title: {
              display: true,
              text: "Percentage of Questions (%)",
            },
          },
        },
      };
    },
  },
  mounted() {
    this.getCompAnalytics();
  },
  methods: {
    ...mapMutations({
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
    }),

    getCompAnalytics() {
      const url = QUIZ_COMPETITION_ADMIN_ANALYTICS;
      const payload = { compId: this.paramsValue.quizCompId };
      this.setOverlayValue(true);
      if (this.paramsValue.status != "DRAFT") {
        axios
          .post(url, payload, getAxiosOptions(BASE_URL, this.token))
          .then((response) => {
            this.compStudents = response.data.students;
            this.compAnalytics = response.data.analytics;

            // if (this.compStudents.length === 0) {
            //   this.compAnalytics = {
            //     enrolled: "-",
            //     participants: "-",
            //     duration: "-",
            //     completionPercentage: "-",
            //     quizId: "-",
            //     quizName: "-",
            //     coinsDistrubuted: "-",
            //     certsCreated: "-",
            //     highestScore: "-",
            //     lowestScore: "-",
            //     maxTime: "-",
            //     minTime: "-",
            //     averageScore: "-",
            //     averageTime: "-",
            //     totalQuestions: "-",
            //   };
            //   this.setOverlayValue(false);
            //   return;
            // }

            const getValidNumber = (value) => {
              if (Array.isArray(value) && value.length === 0) {
                return "-";
              } else if (isFinite(value) && !isNaN(value)) {
                return Math.floor(value);
              } else {
                return "-";
              }
            };

            const highestScore = getValidNumber(
              this.compAnalytics.highestScore
            );
            const lowestScore = getValidNumber(this.compAnalytics.lowestScore);
            const maxTime = this.compAnalytics.maxTime;
            const minTime = this.compAnalytics.minTime;
            const averageScore = getValidNumber(
              this.compAnalytics.averageScore
            );
            const averageTime = this.compAnalytics.averageTime;

            const compAnalytics = {
              enrolled: getValidNumber(this.compAnalytics.enrolled),
              participants: getValidNumber(this.compAnalytics.participants),
              duration: this.compAnalytics.duration,
              completionPercentage: this.compAnalytics.completionPercentage
                ? parseFloat(
                    this.compAnalytics.completionPercentage.replace("%", "")
                  )
                : 0,
              quizId: this.compAnalytics.quizId,
              quizName: this.compAnalytics.quizName,
              coinsDistrubuted: getValidNumber(
                this.compAnalytics.coinsDistrubuted
              ),
              certsCreated: getValidNumber(this.compAnalytics.certsCreated),
              highestScore,
              lowestScore,
              maxTime,
              minTime,
              averageScore,
              averageTime,
              totalQuestions: this.compAnalytics.totalQuestion,
            };

            this.compAnalytics = compAnalytics;
            this.setOverlayValue(false);
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.errorMessage || error.message;
            this.setOverlayValue(false);
            throw new Error(errorMessage);
          });
      }
    },
  },
};
</script>
